import { useNavigate } from "react-router-dom";
import { COLOR, FONT } from "../utils/theme";
import useWindowWidth from "../utils/useWindowWidth";

export default function NotFound() {
  const { isDesktop } = useWindowWidth();
  const navigate = useNavigate();
  return (
    <div style={{
      minHeight: "100vh", background: COLOR.cream,
      display: "flex", alignItems: "center", justifyContent: "center",
      flexDirection: "column",
      padding: !isDesktop ? "0 24px" : undefined,
      textAlign: "center",
    }}>
      <div style={{ fontFamily: FONT.display, fontSize: 24, fontWeight: 300, color: COLOR.inkDark, marginBottom: 8 }}>
        Hmm, that page doesn't exist.
      </div>
      <div style={{ fontFamily: FONT.mono, fontSize: 14, color: COLOR.inkMid, marginBottom: 24 }}>
        But your next trip could.
      </div>
      <button
        onClick={() => navigate("/")}
        style={{
          background: COLOR.mauve, color: COLOR.white, border: "none",
          padding: "10px 24px", borderRadius: 8,
          fontFamily: FONT.mono, fontSize: 14, cursor: "pointer",
          minHeight: 44,
          ...(!isDesktop ? { width: "100%", maxWidth: 320 } : {}),
        }}
      >
        Back to trips
      </button>
    </div>
  );
}
